import { lazy, Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import Banner from "../../Components/Layout/Banner";
import Recommended from "./Recommended";
import Fallback from "../../Components/ErrorBoundary";

const TopSellers = lazy(() => import("./TopSellers"));
const ProductShowcase2 = lazy(() => import("./ProductShowcase2"));
const ProductShowcase4 = lazy(() => import("./ProductShowcase4"));
const FAQs = lazy(() => import("./../../Components/FAQs"));

const SectionSkeleton = () => (
  <div className="animate-pulse px-6 md:px-16 py-10">
    <div className="h-5 bg-gray-200/70 dark:bg-dark-foreground rounded-lg w-44 mb-8"></div>
    <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
      {[...Array(4)].map((_, i) => (
        <div key={i} className="space-y-3">
          <div className="h-40 bg-gray-100 dark:bg-dark-foreground rounded-2xl"></div>
          <div className="h-3.5 bg-gray-100 dark:bg-dark-foreground rounded-lg w-3/4"></div>
          <div className="h-3 bg-gray-100 dark:bg-dark-foreground rounded-lg w-1/2"></div>
        </div>
      ))}
    </div>
  </div>
);

export default function HomeScreen() {
  return (
    <div className="flex flex-col bg-white dark:bg-dark-background font-[sans-serif] min-h-[70px] transition-colors duration-300">
      <Banner />

      <ErrorBoundary FallbackComponent={Fallback} onReset={() => {}}>
        <Suspense fallback={<SectionSkeleton />}>
          <Recommended />
        </Suspense>
      </ErrorBoundary>

      <ErrorBoundary FallbackComponent={Fallback} onReset={() => {}}>
        <Suspense fallback={<SectionSkeleton />}>
          <ProductShowcase2 />
        </Suspense>
      </ErrorBoundary>

      <ErrorBoundary FallbackComponent={Fallback} onReset={() => {}}>
        <Suspense fallback={<SectionSkeleton />}>
          <TopSellers type={"productShowcase3"} />
        </Suspense>
      </ErrorBoundary>

      <ErrorBoundary FallbackComponent={Fallback} onReset={() => {}}>
        <Suspense fallback={<SectionSkeleton />}>
          {/* 'Where to Find the Deals' */}
          <ProductShowcase4 />
        </Suspense>
      </ErrorBoundary>

      <ErrorBoundary FallbackComponent={Fallback} onReset={() => {}}>
        <Suspense fallback={<SectionSkeleton />}>
          <TopSellers type={"productShowcase5"} />
        </Suspense>
      </ErrorBoundary>

      <ErrorBoundary FallbackComponent={Fallback} onReset={() => {}}>
        <Suspense fallback={<SectionSkeleton />}>
          <TopSellers
            type={"productShowcase6"}
            bgColor={"bg-gray-50 dark:bg-dark-foreground"}
          />
        </Suspense>
      </ErrorBoundary>

      <ErrorBoundary FallbackComponent={Fallback} onReset={() => {}}>
        <Suspense fallback={<SectionSkeleton />}>
          <FAQs bgColor="bg-white dark:bg-dark-background" />
        </Suspense>
      </ErrorBoundary>
    </div>
  );
}
